import type { ApiClient } from '@travel/api-client';

import type { ProviderInformation } from 'ProviderInformation-Types';

export const fetchAll = (http: ApiClient, id: string): Promise<ProviderInformation> =>
  http.post(`/monterosa-api/provider-details`, {
    values: { id },
  });
